module.exports = __webpack_public_path__ + "media/images/train-e351bd2403f415fa3357666a5f348749.svg";